export class Sort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
  orders: SortOrder[];

  private constructor(sorted: boolean, unsorted: boolean, empty: boolean, orders: SortOrder[]) {
    this.sorted = sorted;
    this.unsorted = unsorted;
    this.empty = empty;
    this.orders = orders;
  }

  static empty(): Sort {
    return new Sort(false, true, true, []);
  }

  static by(...orders: SortOrder[]): Sort {
    if (!orders || orders.length === 0) {
      return Sort.empty();
    }
    return new Sort(true, false, false, orders);
  }

  static byDirection(direction: Direction, ...properties: string[]): Sort {
    if (!properties || properties.length === 0 || !direction) {
      return Sort.empty();
    }
    return new Sort(
      true,
      false,
      false,
      properties.map((prop) => SortOrder.by(direction, prop))
    );
  }

  toQueryParamValues(): string[] {
    if (!this.sorted) {
      return [];
    }
    return this.orders.map((order) => order.toQueryParamValue());
  }
}

export class SortOrder {
  direction: Direction;
  property: string;

  private constructor(direction: Direction, property: string) {
    this.direction = direction;
    this.property = property;
  }

  static by(direction: Direction, property: string): SortOrder {
    return new SortOrder(direction, property);
  }

  toQueryParamValue(): string {
    return `${this.property},${this.direction.toLowerCase()}`;
  }
}

export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}
